var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _vm.insureType == 3
        ? [_c("product-3-details", { on: { insure: _vm.handleInsure } })]
        : _vm.insureType == 6
        ? [
            _vm.isFgkCommon(_vm.productId)
              ? _c("product-6-common", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm._e(),
            _vm.isFgkCommonYear(_vm.productId)
              ? _c("product-6-common-year", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isFgkZungui(_vm.productId)
              ? _c("product-45-91-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isFgkGangZungui(_vm.productId)
              ? _c("fan6-gang-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isFgkGangCommon(_vm.productId)
              ? _c("product-223-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isFgkDoor(_vm.productId)
              ? _c("product-6-door-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isFgkGuangfu(_vm.productId)
              ? _c("product6guangfu-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm._e(),
          ]
        : _vm.insureType == 10
        ? [_c("product-31-details", { on: { insure: _vm.handleInsure } })]
        : _vm.insureType == 7
        ? [
            _c("product-7-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 8
        ? [
            _c("product-20-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.isYt29(_vm.productId)
        ? [
            _c("product-9-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.isYt30(_vm.productId)
        ? [
            _c("product-30-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 11
        ? [
            _c("product-38-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 12
        ? [
            _vm.isAnZePower(_vm.productId)
              ? _c("product-12-power-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _vm.isAnZeGang(_vm.productId)
              ? _c("product-12-gang-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                })
              : _c("product-12-details", {
                  attrs: { productId: _vm.productId },
                  on: { insure: _vm.handleInsure },
                }),
          ]
        : _vm.isMeiYaB(_vm.insureType, _vm.productId)
        ? [
            _c("product-13-detailsB", {
              attrs: { "product-id": _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.isMeiYaC(_vm.insureType, _vm.productId)
        ? [
            _c("product-13-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 15
        ? [
            _c("product-15-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 14
        ? [
            _c("product-14-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 16
        ? [
            _c("product-16-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 17
        ? [
            _c("product-17-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 18
        ? [
            _c("product-18-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 19
        ? [
            _c("product-19-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 21
        ? [
            _c("product-21-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 22
        ? [
            _c("product-22-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 23
        ? [
            _c("product-23-details", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm.insureType == 29
        ? [
            _c("renbao29", {
              attrs: { productId: _vm.productId },
              on: { insure: _vm.handleInsure },
            }),
          ]
        : _vm._e(),
      _vm.isShowInsureBegin
        ? _c("insure-begin-hint", { ref: "showHint" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }